import React from "react";
import PropTypes from "prop-types";

// The legacy filter chip, and the single place its presentation is defined.
//
// It was briefly copied into three files, and drifted on the first copy (a stray
// `font-semibold`), which is exactly why it lives here now: ChipMultiSelect,
// ChipSingleSelect and anything added later render through this, so "the legacy chip"
// stays one thing.
//
// Copied verbatim from the legacy filter chip: no border, no transform, no shadow, no
// transition, no hover state. Don't add any back.
//
// `text-white-50`, not `text-white` — `white` is a numbered scale with no DEFAULT in
// tailwind.config.js, so `text-white` would emit no CSS at all and the active chip would
// render dark-on-green.
function Chip({ active, disabled, title, onClick, ariaPressed, role, ariaChecked, children }) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            title={title || undefined}
            role={role}
            aria-pressed={ariaPressed}
            aria-checked={ariaChecked}
            className={`text-[10px] px-2 py-1 rounded-[10px] flex items-center gap-2 font-sans disabled:opacity-40 disabled:cursor-not-allowed ${
                active ? "bg-elm-500 text-white-50" : "bg-gray-200 text-[#333]"
            }`}
        >
            {children}
        </button>
    );
}

Chip.propTypes = {
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    /** Tooltip — used to say WHY a chip is disabled, so it never reads as merely broken. */
    title: PropTypes.string,
    onClick: PropTypes.func,
    /** Set for toggle chips; radio-style chips use `role`/`ariaChecked` instead. */
    ariaPressed: PropTypes.bool,
    /** e.g. "radio" for one-of-N chips, so a screen reader announces the exclusivity. */
    role: PropTypes.string,
    ariaChecked: PropTypes.bool,
    children: PropTypes.node,
};

Chip.defaultProps = {
    active: false,
    disabled: false,
    title: null,
    onClick: () => {},
    ariaPressed: undefined,
    role: undefined,
    ariaChecked: undefined,
    children: null,
};

export default Chip;
